import { formatISO, subDays } from "date-fns";
import type { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import { TZDate } from "@date-fns/tz";

import { messages } from "@/globals.content";
import { type RSearchProductType } from "@/schemes/raabits.scheme";

const GERMAN_TIMEZONE = "Europe/Berlin";
// Number of Days a Beitrag is considered new
const NEW_STATUS_THRESHOLD_DAYS = 30;

/**
 * Checks the date.
 * Returns true If the date is younger than or equals 30 days, false otherwise.
 * @param date the date as string in ISO format
 */
export function isDateNew(date: string): boolean {
    return date >= getOldestConsideredNewDate();
}

function getOldestConsideredNewDate(): string {
    const timestamp = TZDate.tz(GERMAN_TIMEZONE);
    return formatISO(subDays(timestamp, NEW_STATUS_THRESHOLD_DAYS), { representation: "date" });
}

type SearchItemBadgeProps = {
    className?: string;
    product: RSearchProductType;
};

/**
 * Parent must position this component (including setting its own position).
 */
export const SearchItemBadgeView = ({
    product,
    className,
}: SearchItemBadgeProps): ReactElement | null => {
    if (!isDateNew(product.portalonlineab)) {
        return null;
    }
    return (
        <div
            className={twMerge(
                "flex items-center justify-center absolute right-3 top-3 z-[1]",
                "rounded-3xl bg-brandYellow py-1 px-3",
                "text-sm leading-4 font-bold text-brand-dark",
                className,
            )}
        >
            {messages.meta.newBadge}
        </div>
    );
};
